import mutations from './organizationUnit.mutations'
import actions from './organizationUnit.actions'
import getters from './organizationUnit.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
